{
  "name": "@arkts/sdk-downloader",
  "type": "module",
  "version": "0.1.30",
  "description": "Download and extract the ArkTS SDK.",
  "author": "Naily Zero <zero@naily.cc>",
  "license": "MIT",
  "homepage": "https://github.com/groupguanfang/arkts-sdk-downloader#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/groupguanfang/arkts-sdk-downloader.git"
  },
  "bugs": {
    "url": "https://github.com/groupguanfang/arkts-sdk-downloader/issues"
  },
  "keywords": [
    "arkts",
    "sdk",
    "downloader",
    "openharmony"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "arkcode-sdk-downloader": "./bin/cli.js"
  },
  "files": [
    "bin",
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "test": "vitest --ui --coverage",
    "build": "tsdown",
    "lint": "eslint .",
    "prepublishOnly": "pnpm build"
  },
  "dependencies": {
    "alien-signals": "^2.0.5",
    "cac": "^6.7.14",
    "fast-glob": "^3.3.3",
    "mitt": "^3.0.1",
    "pino": "^9.7.0",
    "pino-pretty": "^13.0.0",
    "progress-stream": "^2.0.0",
    "tar": "^7.4.3",
    "tar-stream": "^3.1.7",
    "unzipper": "^0.12.3"
  },
  "devDependencies": {
    "@actions/cache": "^4.0.5",
    "@actions/core": "^1.11.1",
    "@antfu/eslint-config": "^4.14.1",
    "@changesets/cli": "^2.29.4",
    "@types/cli-progress": "^3.11.6",
    "@types/node": "^22.15.30",
    "@types/progress-stream": "^2.0.5",
    "@types/tar-stream": "^3.1.4",
    "@types/unzipper": "^0.10.11",
    "@vitest/coverage-v8": "^3.2.2",
    "@vitest/ui": "^3.2.2",
    "cli-progress": "^3.12.0",
    "tsdown": "^0.12.7",
    "tsx": "^4.19.4",
    "typescript": "5.8.3",
    "vitest": "^3.2.2"
  }
}
